<template>
  <div
    class="max-w-[270px] flex-1 xs:max-w-full xs:border-b xs:border-gray-600 xs:pb-8 md:max-w-[270px] md:border-b-0"
  >
    <h3 class="mb-4 text-xl font-medium">
      {{ title }}
    </h3>
    <div :class="contentClass">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  title: string
  contentClass?: string
}>()
</script>

<script lang="ts">
export default {
  name: 'SFFooterSection',
}
</script>
